import { atom } from "recoil";

export interface IExamAbandonState {
  inProgress: boolean;
  requestedNavigation: string | null;
}

export const examAbandonAtom = atom<IExamAbandonState>({
  key: "examAbandon",
  default: {
    inProgress: false,
    requestedNavigation: null,
  },
});
